import { BLAuth } from '@brandlive/client-auth';
import { getPlatformApiHost } from '../utils/hosts';

export default new BLAuth(
	getPlatformApiHost(),
	process.env.REACT_APP_LOGIN_URL as string,
	true,
	{ fromApp: 'Greenroom' }
);
